import { render, staticRenderFns } from "./offer.vue?vue&type=template&id=1830d424&scoped=true"
import script from "./offer.vue?vue&type=script&lang=js"
export * from "./offer.vue?vue&type=script&lang=js"
import style0 from "./offer.vue?vue&type=style&index=0&id=1830d424&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1830d424",
  null
  
)

export default component.exports